// extracted by mini-css-extract-plugin
export default {"secondaryColor":"#374152","breadCrumbsContainer":"breadcrumbsCustomStyle_breadCrumbsContainer__PUYSC","breadcrumbs":"breadcrumbsCustomStyle_breadcrumbs__SAI7v"};